<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="main" >
              <!--详情页 开始-->
              <div class="list-content">
                <!-- 酒店信息，因引入文件方式加载慢，所以不再引入文件 -->
                <!-- <OrderTop :hotelOut="hotel" :orderDataOut="orderData" :source="source" :paymentOn="paymentOn"></OrderTop> -->
                <el-skeleton animated :loading="orderShow">
                  <template slot="template">
                    <div class="hotel-info" style="margin-top: 0px;">
                      <div style="height: 32px; line-height: 32px;">
                        <el-skeleton-item variant="text" style="width: 40%; height: 30px;" />
                      </div>
                      <div style="font-size: 12px; margin-top: 5px;margin-bottom: 15px;"><el-skeleton-item variant="text" style="width: 50%;" /></div>
                      <div style="border-bottom: 1px solid rgba(83, 102, 163, 1); border-width: 1px;"></div>
                      <div class="order-info">
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template>
                    <div class="hotel-info" style="margin-top: 0px;">
                      <div style="height: 32px; line-height: 32px;">
                        <span style="font-size: 28px; font-weight: 650; color: rgba(83, 102, 163, 1);">{{hotel.hotelname_en}}</span>
                        <span style="font-size: 12px; margin-left: 40px; font-weight: 500;">
                          <b style="margin-right: 3px;" v-for="val in hotel.hotelscore" :key="val">
                            <img style="width:15px;height:15px; margin-bottom: 3px;" src="/static/img/star.png">
                          </b>
                          <b style="margin-left: -3px;" v-if="hotel.star_decimal === 1">
                            <img style="width:15px;height:15px; margin-bottom: 3px;" src="/static/img/star-decimal.png">
                          </b>
                        </span>
                      </div>
                      <div style="font-size: 12px; margin-top: 5px;margin-bottom: 15px;">{{hotel.hoteladdress_en}}</div>
                      <div style="border-bottom: 1px solid rgba(83, 102, 163, 1); border-width: 1px;"></div>
                      <div class="order-info">
                        <div class="oneline">
                          <span class="left-info">Room type</span>
                          <span class="right-info">{{orderData.roomName.en}}<a href="javascript:;" @click="showFacilities(orderData)" style="text-align: left; margin-left: 10px;">Facilities & Amenities</a></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Night</span>
                          <span class="right-info">{{orderData.nightCount}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Room</span>
                          <span class="right-info">{{orderData.roomNum.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Guest</span>
                          <span class="right-info">{{orderData.person.en}}<a v-if="orderData.child.en !== ''">, {{orderData.child.en}}</a></span>
                        </div>
                        <!-- <div class="oneline">
                          <span class="left-info">Bed type</span>
                          <span class="right-info">{{orderData.bedType.en}}</span>
                        </div> -->
                        <div class="oneline">
                          <span class="left-info">Bed type</span>
                          <span class="right-info" style="display: inline-flex; align-items: center;">
                            <el-select v-model="bedType" :placeholder="$t('pleaseSelect')" style="width:40%">
                              <el-option v-for="item in orderData.bedGroups" :label="item.description" :key="item.id" :value="item.id" class="option-item">{{item.description}}</el-option>
                            </el-select>
                            <el-tooltip
                              content="Please note: While we do our best to accommodate all bed type requests, they are subject to availability at the time of check-in and cannot be guaranteed."
                              placement="top"
                              effect="light"
                              >
                              <span style="cursor: pointer;color: #000000D9;margin-left: 5px;line-height: 1;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <g clip-path="url(#clip0_694_740)">
                                  <path d="M7.5 0.9375C3.87598 0.9375 0.9375 3.87598 0.9375 7.5C0.9375 11.124 3.87598 14.0625 7.5 14.0625C11.124 14.0625 14.0625 11.124 14.0625 7.5C14.0625 3.87598 11.124 0.9375 7.5 0.9375ZM7.5 12.9492C4.49121 12.9492 2.05078 10.5088 2.05078 7.5C2.05078 4.49121 4.49121 2.05078 7.5 2.05078C10.5088 2.05078 12.9492 4.49121 12.9492 7.5C12.9492 10.5088 10.5088 12.9492 7.5 12.9492Z" fill="black" fill-opacity="0.85"/>
                                  <path d="M6.79665 4.92187C6.79665 5.10836 6.87072 5.2872 7.00259 5.41906C7.13445 5.55092 7.31329 5.625 7.49977 5.625C7.68625 5.625 7.86509 5.55092 7.99695 5.41906C8.12882 5.2872 8.2029 5.10836 8.2029 4.92187C8.2029 4.73539 8.12882 4.55655 7.99695 4.42469C7.86509 4.29283 7.68625 4.21875 7.49977 4.21875C7.31329 4.21875 7.13445 4.29283 7.00259 4.42469C6.87072 4.55655 6.79665 4.73539 6.79665 4.92187ZM7.85133 6.5625H7.14821C7.08376 6.5625 7.03102 6.61523 7.03102 6.67969V10.6641C7.03102 10.7285 7.08376 10.7812 7.14821 10.7812H7.85133C7.91579 10.7812 7.96852 10.7285 7.96852 10.6641V6.67969C7.96852 6.61523 7.91579 6.5625 7.85133 6.5625Z" fill="black" fill-opacity="0.85"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_694_740">
                                    <rect width="15" height="15" fill="white"/>
                                  </clipPath>
                                </defs>
                              </svg></span>
                            </el-tooltip>
                          </span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Check-in</span>
                          <span class="right-info">{{orderData.checkin.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Check-out</span>
                          <span class="right-info">{{orderData.checkout.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Breakfast</span>
                          <span class="right-info" :class="{'green-text': orderData.breakfast.base === '1'}">{{orderData.breakfast.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Cancellation policy</span>
                          <el-popover
                            placement="left"
                            width="350"
                            trigger="hover"
                            popper-class="nonFefundable"
                          >
                          <div class="cancel-policy">
                            <div class="title">Cancellation Policy</div>
                            <div class="content-wrapper">  <!-- 新增一个包装容器 -->
                              <div v-for="(item, i) in orderData.cancelPenalties.list" :key="i" class="content-item">  <!-- 修改class名避免冲突 -->
                                <span class="circle" :style="{ border: '2px solid ' + setCancellationColor(item.type) }"></span>
                                <div class="text-content">
                                  <div class="subtitle">{{ item.title }}</div>
                                  <div class="description">{{ item.desc }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span slot="reference" style="font-size: 14px;cursor:pointer;" :style="{ color: setCancellationColor(orderData.cancelPenalties.cancellation.type)}">{{orderData.cancelPenalties.cancellation.title}}</span>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-skeleton>
                <form>
                  <!-- 客户信息 开始-->
                  <div class="hotel-info" style="padding: 10px 20px 20px;">
                    <div class="hotel-line">
                      <div class="hotel-name" style="font-weight: 650;">Room 1</div>
                      <div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('firstName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" placeholder="Please enter text in English only" maxlength="40" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username1')}" ref="username1" @blur="blurs('username1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username1')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin: 0 4.5%;">
                          <div for="name" class="msg-name">{{$t('lastName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" placeholder="Please enter text in English only" maxlength="40" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('userlastname1')}" ref="userlastname1" @blur="blurs('userlastname1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname1')">
                              <span v-html="getLanguageHtml(userLastNameError,'userLastNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('nationality')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input input-bor">
                              <el-select style="width:100%;" v-model="selectNat[1]" :disabled="nationality" filterable :placeholder="$t('pleaseSelect')">
                                <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id" class="option-item">{{item.country}}</el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!---多个客户信息-->
                    <div class="hotel-line" v-if="guestRoomNum>1" v-for="n in guestRoomNum-1" v-bind:key="n" v-show="true" style="margin-top: 10px;">
                      <div class="hotel-name" style="font-weight: 650;">Room {{n + 1}}</div>
                      <div style="margin-bottom:20px;">
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('firstName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" placeholder="Please enter text in English only" maxlength="40" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :ref="`username${n+1}`" @blur="blursMore('username'+(n+1), 'usernametwo'+(n+1))">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username'+(n+1))">{{$t('pleaseFirstName')}}</div>
                            <div class="el-form-item__error" v-show="getSomeThing('usernametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin: 0 4.5%;">
                          <div for="name" class="msg-name">{{$t('lastName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" placeholder="Please enter text in English only" maxlength="40" :autofocus="inputCursor" class="el-input__inner" :ref="`userlastname${n+1}`" @blur="blursMore('userlastname'+(n+1), 'userlastnametwo'+(n+1))">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname'+(n+1))">{{$t('pleaseLastName')}}</div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastnametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                          </div>
                        </div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('nationality')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <el-select style="width:100%;" v-model="selectNat[n+1]" filterable :placeholder="$t('pleaseSelect')">
                                <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id" class="option-item">{{item.country}}</el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 邮箱和电话 -->
                    <div class="hotel-line" style="margin-top: 20px;">
                      <div class="msg-username">
                        <div for="name" class="msg-name">{{$t('emailAddr')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" :autofocus="inputCursor" class="el-input__inner" :class="{'codeError':getSomeThing('emails')}" ref="emails" @blur="blurs('emails')" :value="userEmail">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('emails')">
                            <span v-html="getLanguageHtml(emailError,'emailError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-username" style="margin: 0 4.5%;">
                        <div for="name" class="msg-name">{{$t('phoneNumber')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input input-bor">
                            <el-select style="width:25%;" :disabled="nationality" v-model="selectTel" :placeholder="$t('pleaseSelect')" @change="telChange">
                              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id" class="option-item">{{item.value}}</el-option>
                            </el-select>
                            <input style="width:73%; float: right;" type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('tel1')}" ref="tel1" @blur="blurs('tel1')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('tel1')">
                            <span v-html="getLanguageHtml(telError,'telError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 客户信息 结束-->
                  <!-- price details 开始-->
                  <div class="hotel-info">
                    <div class="price-details-header">
                      <span class="hotel-name" style="font-weight: 650;">Price details</span>
                      <span class="package-tag" v-if="orderData.isPkg == 1">Package</span>
                    </div>
                    <div class="price-sections-container">
                      <!-- Pay today section -->
                      <div class="price-section">
                        <div class="section-title">Pay today</div>
                        <div class="price-list">
                          <div class="price-box">
                            <div class="price-item">
                              <span>{{orderData.roomCount}} room<span v-if="orderData.roomCount !=='1' && orderData.roomCount !==1">s</span> × {{orderData.nightCount}} night<span v-if="orderData.nightCount !=='1' && orderData.nightCount !==1">s</span></span>
                              <span>{{orderData.fareTotal}}</span>
                            </div>
                            <div class="price-item">
                              <span style="display: inline-flex; align-items: center;">Taxes & fees
                                <el-tooltip
                                content="The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use . Service fees are retained as compensation in servicing your booking and may include fees charged by vendors."
                                placement="top"
                                effect="light"
                                >
                                <span style="cursor: pointer;color: #000000D9;margin-left: 3px;line-height: 1;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style="vertical-align: middle;">
                                    <g clip-path="url(#clip0_694_740)">
                                      <path d="M7.5 0.9375C3.87598 0.9375 0.9375 3.87598 0.9375 7.5C0.9375 11.124 3.87598 14.0625 7.5 14.0625C11.124 14.0625 14.0625 11.124 14.0625 7.5C14.0625 3.87598 11.124 0.9375 7.5 0.9375ZM7.5 12.9492C4.49121 12.9492 2.05078 10.5088 2.05078 7.5C2.05078 4.49121 4.49121 2.05078 7.5 2.05078C10.5088 2.05078 12.9492 4.49121 12.9492 7.5C12.9492 10.5088 10.5088 12.9492 7.5 12.9492Z" fill="black" fill-opacity="0.85"/>
                                      <path d="M6.79665 4.92187C6.79665 5.10836 6.87072 5.2872 7.00259 5.41906C7.13445 5.55092 7.31329 5.625 7.49977 5.625C7.68625 5.625 7.86509 5.55092 7.99695 5.41906C8.12882 5.2872 8.2029 5.10836 8.2029 4.92187C8.2029 4.73539 8.12882 4.55655 7.99695 4.42469C7.86509 4.29283 7.68625 4.21875 7.49977 4.21875C7.31329 4.21875 7.13445 4.29283 7.00259 4.42469C6.87072 4.55655 6.79665 4.73539 6.79665 4.92187ZM7.85133 6.5625H7.14821C7.08376 6.5625 7.03102 6.61523 7.03102 6.67969V10.6641C7.03102 10.7285 7.08376 10.7812 7.14821 10.7812H7.85133C7.91579 10.7812 7.96852 10.7285 7.96852 10.6641V6.67969C7.96852 6.61523 7.91579 6.5625 7.85133 6.5625Z" fill="black" fill-opacity="0.85"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_694_740">
                                        <rect width="15" height="15" fill="white"/>
                                      </clipPath>
                                    </defs>
                                  </svg></span>
                                </el-tooltip>
                              </span>
                              <span>{{orderData.tax}}</span>
                            </div>
                            <div v-if="orderData[paymentOn].pTFee > 0" class="price-item">
                              <span>Transaction fee</span>
                              <span>{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.pTFee[paymentOn]}}</span>
                            </div>
                            <div v-if="isDiscount === true" class="price-item green-text">
                              <span>Coupon</span>
                              <span>
                                {{orderData.discountCode}}
                                <span style="color: rgb(83, 146, 249); cursor: pointer;" @click="delCoupon" >( {{$t('remove')}} )</span>
                              </span>
                            </div>
                          </div>

                          <div class="divider"></div>
                          <div class="price-item total">
                            <span>Total</span>
                            <span v-if="isDiscount === false">{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.payPrice[paymentOn]}}</span>
                            <span v-else>{{orderData.disCurrentCurrency.curMark}}{{orderData.disCurrentCurrency.payPrice[paymentOn]}}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Due at property section -->
                      <div class="price-section" v-if="orderData.payAtProperty !== ''">
                        <div class="section-title">Due at property</div>
                        <div class="price-list">
                          <div class="price-box">
                            <div class="price-item" v-if="orderData.mandatoryFee !== ''">
                              <span>{{$t('mandatoryFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.mandatoryFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.mandatoryTax !== ''">
                              <span>{{$t('mandatoryTax')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.mandatoryTax}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.resortFee !== ''">
                              <span>{{$t('resortFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.resortFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.cityFee !== ''">
                              <span>{{$t('cityTaxFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.cityFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.destinationFee !== ''">
                              <span>{{$t('destinationFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.destinationFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.serviceFee !== ''">
                              <span>{{$t('serviceFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.serviceFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.CleaningFee !== ''">
                              <span>{{$t('cleaningFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.CleaningFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.administrativeFee !== ''">
                              <span>{{$t('administrativeFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.administrativeFee}}</span>
                            </div>
                          </div>
                          <div class="divider"></div>
                          <div class="price-item total">
                            <span>Total</span>
                            <span>{{orderData.payAtProperty}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="total-price">
                      <span>Total price</span>
                      <span v-if="isDiscount === false" style="margin-left: 5px;">{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.totalPrice[paymentOn]}}</span>
                      <span v-else style="margin-left: 5px;">{{orderData.disCurrentCurrency.curMark}}{{orderData.disCurrentCurrency.totalPrice[paymentOn]}}</span>
                    </div>
                  </div>
                  <!-- price details 结束 -->
                  <!-- 支付方式 开始-->
                  <div class="hotel-info" style="padding: 10px 1.5%;">
                    <div class="hotel-name" style="font-weight: 650;">Digital payment</div>
                    <div style="border-bottom: 1.5px solid rgba(83, 102, 163, 1);"></div>
                    <div style=" margin-top: 15px; height: 30px; line-height: 30px;">
                      <el-radio v-model="paymentOn" :label="item" :text-color="radioColor" v-for="item in orderData.paymethod" :key="item">
                        <span v-if="item === 'paypal'">
                          <img src="/static/img/order/paypal-noborder.png" style="height: 21px; width: 80px; margin: 3px 0;">
                        </span>
                        <span v-else-if="item === 'credit'">
                          <img src="/static/img/order/balance.png" style="height: 24px; width: 24px; margin: 3px 0;">
                          <div class="payment-text">Credit</div>
                        </span>
                        <span v-else-if="item === 'pingpong'">
                          <img src="/static/img/order/pingpong.png" style="height: 27px; width: 40px; margin: -1px 5px -1px 0;">
                          <div class="payment-text">Pay by Card</div>
                        </span>
                      </el-radio>
                    </div>
                    <!-- 积分 -->
                    <div style="padding: 20px 0px 10px 0px;">
                      <div style="font-weight: 500;font-size: 16px;line-height: 22px;color: #5566A1;padding-bottom: 10px;display: flex;align-items: center;">Use Points</div>
                      <div style="font-weight: 400;font-size: 14px;line-height: 20px;height: 20px;color: #333333;padding-bottom: 10px;display: flex;align-items: center;">Current Points Balance:{{orderData.currentPoints}}, Points Exchange Rate: 100:{{orderData[paymentOn].PointsPriceRatio * 100}} </div>
                      <div style="display: flex; align-items: center;padding-bottom: 10px;">
                        <div class="el-form-item__content" style="width: 220px;height: 36px;">
                          <div class="el-input">
                            <input type="text" placeholder="Please enter points" maxlength="40" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':validatePointsInput()}" ref="pointsInput" @input="validatePoints" @blur="handlePointsBlur" v-model="pointsValue">
                          </div>
                          <div class="el-form-item__error" style="width: 300px;" v-show="validatePointsInput()">
                            <span>Only multiples of 100 are supported</span>
                          </div>
                        </div>
                        <div style="margin-left: 10px;color: #8E8E8E;"> (Only multiples of 100 are supported.)</div>
                      </div>
                    </div>
                    <!-- 积分 -->
                    <div style="font-size: 14px; display: flex; flex-direction: column;gap: 5px;">
                      <div v-if="(pointsValue && Object.keys(pointData).length > 0 && pointData.usedPointsPrice > 0) || isDiscount === true">
                        <span style="font-weight: 500;">Applied Discounts:</span>
                        <ul style="padding-left: 30px;margin-top: 5px;">
                          <li v-if="isDiscount === true"> Coupon:  <span class="">-{{orderData.discountCode}}</span></li>
                          <li v-if="pointsValue && Object.keys(pointData).length > 0 && pointData.usedPointsPrice > 0"> Points(<span class="">{{pointData.usedPointsAmount}}</span>): <span class="">-{{pointData.curMark}}{{pointData.usedPointsPrice}}</span></li>
                        </ul>
                      </div>
                      <div v-if="orderData[paymentOn].pTFee > 0" style="color: #8E8E8E;">
                        Includes a
                        <span class="" v-if="Object.keys(pointData).length > 0 && pointData.usedPointsPrice > 0">
                          {{pointData.curMark}}{{pointData.pTFee}}</span>
                        <span class="" v-else-if="isDiscount === false">
                          {{orderData[paymentOn].curMark}}{{orderData[paymentOn].pTFee}}</span>
                        <span class="" v-else>
                          {{orderData[paymentOn].curMark}}{{orderData[paymentOn].disPTFee}}</span>
                        <span>
                          transaction fee
                          <el-tooltip
                          content="This fee is charged by the payment provider. To keep our prices low, this cost is passed on to the user."
                          placement="top"
                          effect="light"
                          >
                          <span style="cursor: pointer;">ⓘ</span>
                          </el-tooltip>
                        </span>
                      </div>
                      <div style="font-weight: 500;">
                        Final amount to pay:
                        <span class="" v-if="Object.keys(pointData).length > 0 && pointData.usedPointsPrice > 0">
                          {{pointData.curMark}}{{pointData.payPrice}}</span>
                        <span class="" v-else-if="isDiscount === false">
                          {{orderData[paymentOn].curMark}}{{orderData[paymentOn].payPrice}}</span>
                        <span class="" v-else>
                          {{orderData[paymentOn].curMark}}{{orderData[paymentOn].disPayPrice}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 支付方式 结束 -->
                  <!--特殊要求-->
                  <div class="hotel-info" style="height:135px;padding: 10px 1.5%;">
                    <div class="hotel-name" style="font-weight: 650;">Special request (in English please)</div>
                    <div style="height: 30px; line-height: 30px;">
                      <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"></el-input>
                    </div>
                  </div>
                  <!--运输信息-->
                  <div class="hotel-info" style="height:auto;padding: 10px 1.5% 20px;" v-if="isShowFlight">
                    <div class="hotel-name" style="font-weight: 650;">Transportation Information</div>
                    <div class="transportation">
                      <div style="margin-bottom: 10px; max-width: 100%; /* 您可以根据需要调整这个宽度 */">
                        <el-checkbox v-model="confirmTransportation">I confirm: The above traveler has already booked transportation (flight, cruise, car rental, or long-distance train). During communication with the traveler, room reservations will always be bundled with transportation for pricing, and the traveler will not know the individual room price. The traveler's transportation booking information is as follows:</el-checkbox>
                      </div>
                      <!-- Flight Ticket Section -->
                      <div style="padding-bottom: 10px; border-bottom: 1px solid #eee; margin-bottom:15px;">
                        <span style="border-top-left-radius:8px;border-top-right-radius:8px;padding: 5px 20px;background: #3333330D;font-weight: bold; font-size: 1em; color: #333; border-bottom: 2px solid #409EFF; padding-bottom: 8px;">Flight Ticket</span>
                      </div>

                      <div class="hotel-line">
                        <div class="msg-username">
                          <div for="name" class="msg-name">Flight Number*</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError': flightNumberError}" ref="flightNumber" @blur="validateField('flightNumber')" v-model="flightNumber"  placeholder="Flight Number">
                            </div>
                            <div class="el-form-item__error" v-show="flightNumberError">
                              Please enter your flight number.
                            </div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin: 0px 4.5%;">
                          <div for="name" class="msg-name">Flight Date*</div>
                          <div class="el-form-item__content">
                            <el-date-picker
                              v-model="flightDate"
                              type="date"
                              placeholder="Please select flight date"
                              style="width: 100%;"
                              :class="{'codeError': flightDateError}"
                              ref="flightDate"
                              @blur="validateField('flightDate')"
                              @change="validateField('flightDate')">
                            </el-date-picker>
                            <div class="el-form-item__error" v-show="flightDateError">
                              Please select flight date
                            </div>
                          </div>
                        </div>

                        <div class="msg-username">
                          <div for="name" class="msg-name">Departure Airport*</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError': departureAirportError}" ref="departureAirport" @blur="validateField('departureAirport')" v-model="departureAirport" placeholder="Departure Airport">
                            </div>
                            <div class="el-form-item__error" v-show="departureAirportError">
                              Please enter departure airport
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="hotel-line" style="margin-top: 20px;">
                        <div class="msg-username">
                          <div for="name" class="msg-name">Arrival Airport*</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError': arrivalAirportError}" ref="arrivalAirport" @blur="validateField('arrivalAirport')" v-model="arrivalAirport" placeholder="Arrival Airport">
                            </div>
                            <div class="el-form-item__error" v-show="arrivalAirportError">
                              Please enter arrival airport
                            </div>
                          </div>
                        </div>

                        <div class="msg-username" style="margin: 0px 4.5%;">
                          <div for="name" class="msg-name">Ticket Number*</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError': ticketNumberError}" ref="ticketNumber" @blur="validateField('ticketNumber')" v-model="ticketNumber" placeholder="Ticket Number">
                            </div>
                            <div class="el-form-item__error" v-show="ticketNumberError">
                              Please enter ticket number
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--订房须知-->
                  <div class="container">
                    <h1>Hotel Policies</h1>
                    <div class="policy-columns">
                      <div class="policy-column">

                        <div class="policy-module" v-if="hotelPolicyData.checkin_begin_time">
                          <h2>Check In</h2>
                          <div>Check in time: {{hotelPolicyData.checkin_begin_time}} - {{hotelPolicyData.checkin_end_time}}</div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.checkout_time_en">
                          <h2>Check out</h2>
                          <div>Check out time: {{hotelPolicyData.checkout_time_en}}</div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.hotel_checkin_instructions_en">
                          <h2>Instructions</h2>
                          <div class="policy-content" v-html="hotelPolicyData.hotel_checkin_instructions_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.special_instructions_en">
                          <h2>Special Instructions</h2>
                          <div class="policy-content" v-html="hotelPolicyData.special_instructions_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.fees_mandatory_en">
                          <h2>Fees</h2>
                          <div class="policy-content" v-html="hotelPolicyData.fees_mandatory_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.other_policies_en">
                          <h2>Policies</h2>
                          <div class="policy-content" v-html="hotelPolicyData.other_policies_en"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--订房须知-->
                  <div class="hotel-info" style="height:auto;padding: 10px 1.5%;" v-if="orderData.hotelFeesEnText !== ''">
                    <div class="hotel-name" style="font-weight: 650;">{{$t('bookingNotice')}}</div>
                    <div style="padding: 2px 1.5%;">
                      <p style="font-size:14px;" class="hotelFeesText" v-html="orderData.hotelFeesEnText"></p>
                    </div>
                  </div>
                  <div class="hotel-info" style="background: rgba(242, 242, 242, 1); height:auto;padding: 10px 1.5%;">
                    <div style="margin-bottom: 10px; max-width: 100%; /* 您可以根据需要调整这个宽度 */">
                      <el-checkbox v-model="confirmAgreement">I understand and accept that package rates can only be booked in combination with a flight, car, train or cruise booking for the same traveller and trip.</el-checkbox>
                      <div style="margin-top: 10px;">By clicking Pay now, you also agree to the <a href="https://developer.expediapartnersolutions.com/terms/agent/en/" target="_blank" style="color: #007AFF; text-decoration: none;">AGENT TERMS OF USE</a> and the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank" style="color: #007AFF; text-decoration: none;">Terms and Conditions</a>.</div>
                    </div>
                  </div>
                  <!--前往最后一步-->
                  <div style="width: 100%; height: 100px; text-align: center; margin-top: 40px;">
                    <el-button type="button" v-if="allPermissions.pay === 0" style="float: none; margin-top: 12.5px;" class="display_button">{{$t('goPay')}}</el-button>
                    <el-button type="button" v-else style="float: none; margin-top: 12.5px;" :style="{cursor: confirm ? 'pointer' : 'not-allowed'}" :class="[ confirm ? 'booknow_button' : 'display_button']" @click="JumpNext" :disabled="!confirm">{{$t('goPay')}}</el-button>
                  </div>
                </form>
              </div>
            </div>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
    <frameRefresh :frameDialog="frameDialog"></frameRefresh>
    <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut" :nationality="paramsNationality"></frameHotelSold>
    <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
    <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog" :nationality="paramsNationality"></frameHomeSold>
<!--    <frameQuotation :frameQuotationDialog="frameQuotationDialog"></frameQuotation>-->
    <frameRemind :frameRemindDialog="frameRemindDialog" @continueBookingFun="continueBookingFun"></frameRemind>
    <frameToolong :frameToolongDialog="frameToolongDialog"></frameToolong>
    <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
    <frameNotice :frameNoticeDialog="frameNoticeDialog" @frameNoticeFun="frameNoticeFun"></frameNotice>
    <frameNoLimit :frameNoLimitDialog="frameNoLimitDialog" @SetFrameNoLimit="SetFrameNoLimit"></frameNoLimit>
    <publicMask :fullscreenLoading="fullscreenLoading || frameQuotationDialog"></publicMask>
    <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" @frameChangeRoomBookingFun="frameChangeRoomBookingFun" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
    <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingFun="frameChangePriceAndRoomBookingFun" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
    <el-dialog
      title="Facilities & Amenities"
      :visible.sync="facilitiesDialogVisible"
      width="30%"
      custom-class="facilities-dialog"
      >
      <div class="facilities-divider"></div>
      <ul class="facilities-list">
        <li v-for="item in amenities" :key="item.name">
          <span class="arrow-icon">►</span>
          <span>{{ item.name }}</span>
        </li>
        <li v-for="item in promotions" :key="item.id">
          <span class="arrow-icon">►</span>
          <span>{{ item.description }}</span>
        </li>
      </ul>
    </el-dialog>
  </el-container>
  </template>

<script>
import { orderBookVerify, writeOrderShow, orderFillCosInfo, getOrderPrice } from '@/request/order.js'
import { hotelPolicyNew } from '@/request/hotel.js'
import { signIn } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import OrderTop from '@/components/order/module/OrderTop'
import frameRefresh from '@/components/public/frameRefresh'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import frameQuotation from '@/components/public/frameQuotation'
import frameRemind from '@/components/public/frameRemind'
import frameToolong from '@/components/public/frameToolong'
import frameNetwork from '@/components/public/frameNetwork'
import frameNotice from '@/components/public/frameNotice'
import frameNoLimit from '@/components/public/frameNoLimit'
import publicMask from '@/components/public/publicMask'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'

export default {
  name: 'WriteOrder',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    frameRefresh,
    frameHotelSold,
    frameHomeSold,
    frameRise,
    frameQuotation,
    frameRemind,
    frameToolong,
    frameNetwork,
    frameNotice,
    frameNoLimit,
    OrderTop,
    publicMask,
    frameChangeRoom,
    frameChangePriceAndRoom
  },
  data () {
    return {
      curPageData: 'WriteOrder',
      hotelid: 0,
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': '', 'paypal': {'curMark': '', 'payPrice': 0, pTFee: 0}, 'currentCurrency': {curMark: '', 'pTFee': {'paypal': 0, wechat: 0, limit: 0}, 'payPrice': {'paypal': 0, wechat: 0, limit: 0}, 'totalPrice': {'paypal': 0, wechat: 0, limit: 0}}},
      remainTime: 300,
      guestRoomNum: 2,
      guestRoomMore: false,
      userLastNameError: 'pleaseLastName',
      userNameError: 'pleaseFirstName',
      emailError: 'pleaseEnterYourEmailOrYouMightMissBooking',
      telError: 'pleaseValidPhone',
      emailConfirmError: 'pleaseEmailFieldsMatch',
      desc: '',
      telOptions: [{id: 1, alue: '法国 +33', telnum: '+33'}, {id: 2, value: '瑞典 +46', telnum: '+46'}, {id: 3, value: '美国 +1', telnum: '+1'}, {id: 4, value: '中国 +0086', telnum: '+0086'}],
      selectTel: '216',
      selectNat: {1: '216'},
      minute: '',
      second: '',
      fullscreenLoading: false,
      promiseTimer: '',
      frameDialog: false, // 弹框1
      frameHotelSoldDialog: false, // 弹框2
      frameHomeSoldDialog: false, // 弹框3
      frameRiseDialog: false, // 弹框4
      frameQuotationDialog: false, // 弹框5
      frameRemindDialog: false, // 弹框7
      frameToolongDialog: false,
      frameNetworkDialog: false,
      frameNoticeDialog: false,
      risePrice: 12.5,
      homeSurplus: 3,
      screenWidth: 0,
      currencyShow: false, // 币种是否显示
      loginStatus: false,
      userEmail: '',
      cancelData: 0,
      pageRefresh: 0,
      pageVerifyNum: 1,
      pageVerifyTimer: '',
      orderWritePageTime: 600,
      language: this.common.languageSet(this),
      orderno: '',
      guestClicksRetry: 0,
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      ismobile: false,
      taxWidth: 327,
      taxDia: false,
      commissionDia: false,
      taxShowClose: false,
      special: '',
      elementWidth: document.documentElement.clientWidth,
      stepWidth: document.documentElement.clientWidth - 20,
      policyDialog: false,
      clauseDialog: false,
      source: this.common.sourceSet(),
      inputCursor: true, // 登录数据
      mobileOverview: false, // 订房须知
      cancelDia: false,
      cancelShowClose: false,
      canceltextZh: '',
      canceltextEn: '',
      mandatoryFeeDetail: false,
      payment: {'total': {'status': '0'}},
      payment_card_show: false,
      paymentMobileList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}],
      paymentOn: 'paypal',
      activeName: 'electronicPayment',
      paymentCardno: '0',
      paymentCardnoName: '',
      paymentCardnoEffectivedate: '',
      paymentCardnoValidCVV: '',
      showCardRemindTwo: false,
      securityCodeShow: false,
      showCardRemind: false,
      securityCodeShowTwo: false,
      cardNoError: 'validCardNumber',
      effectiveDateError: 'pleaseValidCardExpiry',
      securityCodeError: 'validCVV',
      cardNo: '',
      checked: false,
      checkIn: '',
      checkOut: '',
      ratio: 1,
      isDiscount: false,
      userCouponId: '',
      TransactionFeeshow: false,
      hotelInfo: {},
      orderShow: true,
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      radioColor: ' rgba(241, 81, 27, 1)',
      showClo: false,
      diaWidth: '500px',
      frameNoLimitDialog: false,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      searchjson: {},
      frameChangeRoomDialog: false, // 价格不变，房型变更弹框
      frameChangePriceAndRoomDialog: false, // 价格变更，房型变更
      sameRoomInfo: '',
      paramsNationality: '',
      nationality: false,
      searchNat: 0,
      pointsValue: '',
      someArray: {
        pointsVal: false
      },
      pointData: {},
      bedType: '',
      confirmTransportation: false,
      confirmAgreement: false,
      flightNumber: '',
      flightDate: null,
      departureAirport: '',
      arrivalAirport: '',
      ticketNumber: '',
      flightNumberError: false,
      flightDateError: false,
      departureAirportError: false,
      arrivalAirportError: false,
      ticketNumberError: false,
      hotelPolicyData: {},
      isShowFlight: false,
      facilitiesDialogVisible: false,
      promotions: [],
      amenities: []
    }
  },
  created () {
    var searchAgreementChange = sessionStorage.getItem('searchAgreementChange')
    if (searchAgreementChange === 1 || searchAgreementChange === '1') {
      this.isShowFlight = true
    }
    // 判断是否登录
    if (localStorage.getItem('token')) {
      this.inputCursor = false
    }
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 请求页面展示数据
    this.pageShow()
    var width = document.documentElement.clientWidth
    this.taxWidth = width - 40

    var time = parseInt(new Date().getTime() / 1000)
    var sessionid = this.common.sessionidGet(this)
    var policyDataJson = {'hotelid': this.hotelid, 'operation': 'hotelPolicyNew', 'time': time, 'sessionid': sessionid}
    var policyData = this.common.encryptionData(policyDataJson, this)
    hotelPolicyNew(policyData).then(res => {
      this.hotelPolicyData = res.data
    })
  },
  mounted () {
    var that = this
    // 错误提示
    this.userLastNameError = ''
    this.userNameError = ''
    this.emailError = ''

    if (this.remainTime > 0) {
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    // 监听点击事件
    document.addEventListener('click', function (e) {
      var cardRemindShow = true
      for (var i = 0; i < e.target.classList.length; i++) {
        if (e.target.classList[i] === 'cardRemindShow') {
          cardRemindShow = false
        }
      }
      if (cardRemindShow) {
        that.showCardRemind = false
        that.showCardRemindTwo = false
      }
    })

    // 填入默认用户信息
    this.pageUserShow()

    // 默认电子支付
    // if (this.common.isMobile() === false) {
    // this.changePayment(this.paymentOn)
    // } else {
    //   this.changePaymentMobile(this.paymentOn)
    // }
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1000) {
        this.ismobile = true
      } else {
        this.ismobile = false
      }
    },
    pageVerifyNum: function (news, olds) {
      if (news > 3) {
        this.frameRemindDialog = true
        // 结束定时器
        clearInterval(this.pageVerifyTimer)
      } else {
        this.pageRefresh = 0
        this.frameQuotationDialog = true
        this.orderVerify()
      }
    },
    language: function (newCur, oldCur) {
      this.pageShow()
    },
    $route: function (to, from) {
      console.log(to, from)
    },
    paymentOn: function (n, o) {
      if (n === 'paypal' && this.orderData.pTFee !== 0 && this.orderData.pTFee !== '0') {
        this.TransactionFeeshow = true
      } else {
        this.TransactionFeeshow = false
      }
    }
  },
  methods: {
    showFacilities (orderData) {
      this.amenities = orderData.amenities
      this.promotions = orderData.promotions
      this.facilitiesDialogVisible = true
    },
    setCancellationColor (value) {
      if (value === '1' || value === 1) {
        return '#007f61'
      } else if (value === '2' || value === 2) {
        return '#d99c00'
      } else {
        return '#cc0000'
      }
    },
    validateField (fieldName) {
      switch (fieldName) {
        case 'flightNumber':
          this.flightNumberError = !this.flightNumber || this.flightNumber.trim() === ''
          break
        case 'flightDate':
          this.flightDateError = !this.flightDate
          break
        case 'departureAirport':
          this.departureAirportError = !this.departureAirport || this.departureAirport.trim() === ''
          break
        case 'arrivalAirport':
          this.arrivalAirportError = !this.arrivalAirport || this.arrivalAirport.trim() === ''
          break
        case 'ticketNumber':
          this.ticketNumberError = !this.ticketNumber || this.ticketNumber.trim() === ''
          break
      }
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    refreshUrl () {
      this.pageShow()
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    getSite () {
      let site = ''
      if (location.host === 'www.roompai.com') {
        site = 'www'
      } else if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
        site = 'us'
      }
      return site
    },
    hotelLanguage (language) {
      this.language = language
    },
    getfirstName (firstName) {
      this.firstName = firstName
    },
    checkSpecial () {
      this.special = this.special.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    pageUserShow: function () {
      var orderUserDataJson = sessionStorage.getItem('orderUserData')
      var orderUserData = JSON.parse(orderUserDataJson)
      if (orderUserData === null) {
        this.$refs['emails'].value = this.userEmail
        return ''
      }

      if (orderUserData.roomHost.emails !== '') {
        this.$refs['emails'].value = orderUserData.roomHost.emails
      } else {
        this.$refs['emails'].value = this.userEmail
      }

      if (orderUserData.roomHost.areaCode !== '') {
        this.selectTel = orderUserData.roomHost.areaCode
      }
      if (orderUserData.roomHost.emails !== '') {
        this.$refs['tel1'].value = orderUserData.roomHost.tel
      }
      if (orderUserData.roomHost.specialRequirements !== '') {
        this.special = orderUserData.roomHost.specialRequirements
      }
      if (orderUserData.roomHost.nationality !== '') {
        this.selectNat[1] = orderUserData.roomHost.nationality
      }
      if (orderUserData.roomOther !== '[]') {
        for (var item in orderUserData.roomOther) {
          var key = parseInt(item)
          var index = key + 2

          this.$refs['userlastname' + index][0].value = orderUserData.roomOther[key].userlastname
          this.$refs['username' + index][0].value = orderUserData.roomOther[key].username
          this.selectNat[index] = orderUserData.roomOther[key].nationality
        }
      }
    },
    // 请求页面展示数据
    pageShow: function () {
      var that = this
      this.orderShow = true
      let locationHref = window.document.location.href
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      if (params === undefined || params === null || params === '') {
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        if (this.source !== '') {
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else {
          this.$router.push({name: 'login'})
        }
      }
      this.hotelid = params.hotelid
      this.guestRoomNum = params.room

      if (params.childNums === undefined) {
        params.childNums = []
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      this.checkIn = params.checkin
      this.checkOut = params.checkout
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)
      this.source = this.common.sourceSet()
      // this.source = params.source
      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'time': time,
        'source': this.source,
        'currency': currency,
        'language': this.language,
        'sessionid': sessionid,
        'operation': 'writeOrderShow'
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      writeOrderShow(orderDataShow).then(res => {
        if (res.flag === '110') {
          var regionSel = {'value_zh': this.orderData.roomName.zh, 'value_en': this.orderData.roomName.en, 'type_id': 1, 'type_data_id': params.hotelid}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
          this.searchjson['start_date'] = params.checkin
          this.searchjson['end_date'] = params.checkout
          this.searchjson['room'] = params.room
          this.searchjson['adult'] = params.adult
          this.searchjson['child'] = params.child
          this.searchjson['childNums'] = params.childNums
          this.searchjson['type'] = 3
          this.searchjson['type_id'] = params.hotelid
          this.searchjson['region'] = this.orderData.roomName.en
          this.searchjson['source'] = this.source
          this.$router.push({name: 'HotelList', query: this.searchjson})
        } else if (res.flag === '001') {
          localStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '165') {
          // 进入订单填写页面超过规定时间
          this.frameToolongDialog = true
        } else {
          if (res.data.orderData.createtime !== 0) {
            this.orderWritePageTime = res.data.orderData.orderWritePageTime

            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.orderData.createtime)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
          }

          // 信息
          this.hotel = res.data.hotel
          this.telOptions = res.data.countryCode
          var nat = res.data.defaultCode
          if (nat !== '') {
            this.selectTel = nat
            this.selectNat = {1: this.selectTel}
            this.nationality = true
            this.searchNat = 1
            var productInfo = params.product
            productInfo = JSON.parse(productInfo)
            this.paramsNationality = productInfo.nationality
          } else {
            this.selectTel = '216'
            this.selectNat = {1: this.selectTel}
            this.nationality = false
            this.searchNat = 0
            this.paramsNationality = ''
          }
          this.cancelData = res.data.orderData.cancelData.en
          this.loginStatus = res.data.orderData.loginStatus
          this.userEmail = res.data.orderData.useremail
          this.guestRoomNum = res.data.orderData.selectRoom
          this.orderData = res.data.orderData
          this.canceltextZh = this.orderData.canceltext.zh
          this.canceltextEn = this.orderData.canceltext.en
          if (this.orderData.discount !== '') {
            this.isDiscount = true
            this.userCouponId = this.orderData.user_coupon_id
          } else {
            this.isDiscount = false
            this.userCouponId = ''
          }
          // 默认支付方式逻辑.
          if (this.orderData.paymethod.includes(this.orderData.paymethodDefault)) {
            this.paymentOn = this.orderData.paymethodDefault
          }
          if (this.paymentOn === 'paypal' && this.orderData.pTFee !== 0 && this.orderData.pTFee !== '0') {
            this.TransactionFeeshow = true
          } else {
            this.TransactionFeeshow = false
          }

          var bedTypeId = sessionStorage.getItem('bedType_' + this.hotel.hotelid)
          if (bedTypeId === undefined) {
            this.bedType = this.orderData.bedGroups[0].id
          } else {
            this.bedType = bedTypeId
          }
          that.pageUserShow()

          // 判断夜是否大于1
          if (this.language === 'en' && res.data.orderData.night.en > 1) {
            this.dateNumComplexStr = 's'
          } else {
            this.dateNumComplexStr = ''
          }
          // 判断房间是否大于1
          if (this.language === 'en' && res.data.orderData.roomNum.en > 1) {
            this.roomNumComplexStr = 's'
          } else {
            this.roomNumComplexStr = ''
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderDataShow, res, requestTime, responseTime)
        })
      })
      this.orderShow = false
    },
    // 积分展示数据
    pointShow: function () {
      this.orderShow = true
      let locationHref = window.document.location.href
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      if (params === undefined || params === null || params === '') {
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        if (this.source !== '') {
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else {
          this.$router.push({name: 'login'})
        }
      }
      this.hotelid = params.hotelid
      this.guestRoomNum = params.room

      if (params.childNums === undefined) {
        params.childNums = []
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      this.checkIn = params.checkin
      this.checkOut = params.checkout
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)
      this.source = this.common.sourceSet()
      // this.source = params.source
      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'time': time,
        'source': this.source,
        'currency': currency,
        'language': this.language,
        'sessionid': sessionid,
        'userCouponId': this.userCouponId,
        'usedPoints': this.pointsValue,
        'operation': 'getOrderPrice',
        'paymentOn': this.paymentOn
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      getOrderPrice(orderDataShow).then(res => {
        if (res.flag === '200') {
          this.pointData = res.data
          localStorage.setItem('getPointsValue', this.pointsValue)
        } else {
          this.pointsValue = 0
        }
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderDataShow, res, requestTime, responseTime, 'pointShow')
        })
      }).finally(() => {
        this.orderShow = false
      })
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError', 'cardNoError', 'effectiveDateError', 'securityCodeError', 'emailError', 'telError', 'emailConfirmError', 'paymentLabel'].includes(type)) {
        return this.$t(data)
      } else if (['buttonMeansYouAgree'].includes(type)) {
        return this.$t(type)
      }
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        if (refInfo === 'userlastname1') {
          this.userLastNameError = 'pleaseLastName'
        }
        if (refInfo === 'username1') {
          this.userNameError = 'pleaseFirstName'
        }
        if (refInfo === 'emails') {
          this.emailError = 'pleaseEnterYourEmailOrYouMightMissBooking'
        }
        this.$set(this.someArray, refInfo, true)
      } else {
        var pattern = ''
        if (refInfo === 'userlastname1') {
          this.userLastNameError = ''
        }
        if (refInfo === 'username1') {
          this.userNameError = ''
        }

        if (refInfo === 'emails') {
          // pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+.([a-zA-Z]{2,4})$/
          pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!pattern.test(refName)) {
            this.emailError = 'pleaseValidEmailReservationConfirmationEmail'
            this.$set(this.someArray, refInfo, true)
          } else {
            this.userEmail = refName
            this.$set(this.someArray, refInfo, false)
          }
        } else if (refInfo === 'tel1') {
          pattern = /^[0-9]*$/
          if (this.selectTel === '42') {
            pattern = /^1[0-9]{10}$/
          }
          if (!pattern.test(refName)) {
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else {
          pattern = /^[a-zA-Z\s]+$/
          // 不支持单引号
          // var pattern1 = new RegExp("[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}':;'/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
          // 支持单引号
          // var pattern1 = new RegExp('[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}:;/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？%+_]')
          if (!pattern.test(refName)) {
            if (refInfo === 'userlastname1') {
              this.userLastNameError = 'pleaseTextEnglish'
            }
            if (refInfo === 'username1') {
              this.userNameError = 'pleaseTextEnglish'
            }
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        }
      }

      this.frameRiseDialog = false
      this.frameChangeRoomDialog = false
      this.frameChangePriceAndRoomDialog = false
    },
    blursMore (refInfo, refInfoTwo) {
      // var pattern = new RegExp(/[\u4e00-\u9fa5/\s+/]|[`~!@#$%^&*() \\+ =<>?"{}|, \\/ ;' \\ [ \] ·~！@#￥%……&*（）—— \\+ ={}|《》？：“”【】、；‘’，。、_.-:]/g)
      var refName = this.$refs[refInfo][0].value
      if (refName === '' || refName === null) {
        this.$set(this.someArray, refInfo, true)
        this.$set(this.someArray, refInfoTwo, false)
      } else {
        // var pattern = new RegExp('[A-Za-z]+')
        // var pattern1 = new RegExp("[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}':;'/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
        // var pattern1 = new RegExp('[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}:;/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？%+_]')
        var pattern = /^[a-zA-Z\s]+$/
        if (!pattern.test(refName)) {
          this.$set(this.someArray, refInfo, false)
          this.$set(this.someArray, refInfoTwo, true)
        } else {
          this.$set(this.someArray, refInfo, false)
          this.$set(this.someArray, refInfoTwo, false)
        }
      }
    },
    formatCardNumber (e) {
      const input = e.target
      const cursorIndex = input.selectionStart
      const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
      const noLine = e.target.value.replace(/\s/g, '')
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
      this.$nextTick(() => {
        this.cardNo = newCardNum
        this.$nextTick(() => {
          input.selectionStart = newCursorIndex
          input.selectionEnd = newCursorIndex
        })
      })
    },
    blursCode (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        this.securityCodeShow = true
      } else {
        if (refName.length !== 3) {
          this.securityCodeShow = true
        } else {
          this.securityCodeShow = false
        }
      }
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    telChange () {
      this.selectNat[1] = this.selectTel
    },
    JumpNext () {
      let locationHref = window.document.location.href
      // 第一位客户
      this.$options.methods.blurs.bind(this)('userlastname1')
      let userlastname1R = this.$options.methods.getSomeThing.bind(this)('userlastname1')
      if (userlastname1R === true) {
        this.$refs['userlastname1'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('username1')
      let username1R = this.$options.methods.getSomeThing.bind(this)('username1')
      if (username1R === true) {
        this.$refs['username1'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('emails')
      let emailsR = this.$options.methods.getSomeThing.bind(this)('emails')
      if (emailsR === true) {
        this.$refs['emails'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('tel1')
      let tel1R = this.$options.methods.getSomeThing.bind(this)('tel1')
      if (tel1R === true) {
        this.$refs['tel1'].focus()
        return false
      }
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        // let userlastnames = this.$refs['userlastname' + index][0].value
        this.$options.methods.blursMore.bind(this)('userlastname' + index, 'userlastnametwo' + index)
        let userlastnameR1 = this.$options.methods.getSomeThing.bind(this)('userlastname' + index)
        let userlastnameR2 = this.$options.methods.getSomeThing.bind(this)('userlastnametwo' + index)
        if (userlastnameR1 === true || userlastnameR2 === true) {
          this.$refs['userlastname' + index][0].focus()
          return false
        }
        this.$options.methods.blursMore.bind(this)('username' + index, 'usernametwo' + index)
        let usernameR1 = this.$options.methods.getSomeThing.bind(this)('username' + index)
        let usernameR2 = this.$options.methods.getSomeThing.bind(this)('usernametwo' + index)
        if (usernameR1 === true || usernameR2 === true) {
          this.$refs['username' + index][0].focus()
          return false
        }
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        // var nationalityR = this.$refs['nationality' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      if (this.isShowFlight) {
        this.validateField('flightNumber')
        if (this.flightNumberError) {
          this.$refs['flightNumber'].focus()
          return false
        }

        this.validateField('flightDate')
        if (this.flightDateError) {
          this.$refs['flightDate'].focus()
          return false
        }

        this.validateField('departureAirport')
        if (this.departureAirportError) {
          this.$refs['departureAirport'].focus()
          return false
        }

        this.validateField('arrivalAirport')
        if (this.arrivalAirportError) {
          this.$refs['arrivalAirport'].focus()
          return false
        }

        this.validateField('ticketNumber')
        if (this.ticketNumberError) {
          this.$refs['ticketNumber'].focus()
          return false
        }
      }

      this.fullscreenLoading = true

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      var flightDateStr = ''
      const flightDateValue = this.flightDate
      if (flightDateValue && typeof flightDateValue.toISOString === 'function') {
        flightDateStr = flightDateValue.toISOString().split('T')[0]
      }

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1,
          'username': username1,
          'emails': emails,
          'tel': tel1,
          'specialRequirements': specialRequirements,
          'areaCode': this.selectTel,
          'nationality': this.selectNat[1]
        },
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      // 订单信息
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var currency = this.common.currencySet(this)
      var language = this.common.languageSet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var platfromParam = sessionStorage.getItem('platfromParam')
      if (platfromParam === null || platfromParam === 'null' || platfromParam === undefined) {
        platfromParam = ''
      }

      var localUrl = params.hotelUrl !== undefined ? params.hotelUrl : ''

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      this.source = this.common.sourceSet()

      // 获取积分数值
      const usedPoints = this.pointsValue || '0'
      if (usedPoints !== '0') {
        if (this.validatePointsAmount()) {
          this.fullscreenLoading = false
          this.$message.error('Points amount cannot exceed payable amount')
          return
        }
        // 检查积分是否超出可用余额
        if (Number(usedPoints) > Number(this.orderData.currentPoints)) {
          this.fullscreenLoading = false
          this.$message.error('Points cannot exceed available balance (Point: ' + this.orderData.currentPoints + ')')
          return
        }
        // 检查是否为100的倍数
        if (this.getSomeThing('pointsVal')) {
          this.fullscreenLoading = false
          this.$message.error('Points only support multiples of 100')
          return
        }
      }

      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'userlastname': userlastname1,
        'username': username1,
        'emails': emails,
        'tel': tel1,
        'areaCode': this.selectTel,
        'nationality': this.selectNat[1],
        'userOtherInfo': JSON.stringify(userOtherInfo),
        'specialRequirements': specialRequirements,
        'usedPoints': usedPoints,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums === undefined ? [] : params.childNums,
        'product': params.product,
        'time': time,
        'source': this.source,
        'currency': currency,
        'language': language,
        'sessionid': sessionid,
        'guestClicksRetry': this.guestClicksRetry,
        'platfromParamLs': platfromParam,
        'operation': 'orderFillCosInfo',
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'page_site': 'hibeds',
        'paymentOn': this.paymentOn,
        'searchNat': this.searchNat,
        'userCouponId': this.userCouponId,

        'flightNumber': this.flightNumber,
        'validFlyDate': flightDateStr,
        'validDeparture': this.departureAirport,
        'validArrival': this.arrivalAirport,
        'validReservationCode': this.ticketNumber,
        'bedTypePreferenceId': this.bedType
      }
      var orderFillInfo = this.common.encryptionData(orderDataJson, this)
      // 点击booking记录埋点
      orderFillCosInfo(orderFillInfo).then(res => {
        // 点击完成 埋点记录
        this.clickPageAction('nextFinalstep', '', orderDataJson, orderFillInfo, res)

        this.fullscreenLoading = false
        if (res.flag === '110') {
          var regionSel = {'value_zh': this.orderData.roomName.zh, 'value_en': this.orderData.roomName.en, 'type_id': 1, 'type_data_id': params.hotelid}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
          this.searchjson['start_date'] = params.checkin
          this.searchjson['end_date'] = params.checkout
          this.searchjson['room'] = params.room
          this.searchjson['adult'] = params.adult
          this.searchjson['child'] = params.child
          this.searchjson['childNums'] = params.childNums
          this.searchjson['type'] = 3
          this.searchjson['type_id'] = params.hotelid
          this.searchjson['region'] = this.orderData.roomName.en
          this.searchjson['source'] = this.source
          this.$router.push({name: 'HotelList', query: this.searchjson})
        } else if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '155') {
          // 无母房型有报价
          this.frameHotelSoldDialog = true
          this.orderno = res.data.orderno
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
          this.orderno = res.data.orderno
        } else if (res.flag === '153') {
          // 涨价
          this.frameRiseDialog = true
          this.risePrice = res.data.priceRise
          this.orderno = res.data.orderno
        } else if (['157', '500', '177'].includes(res.flag)) {
          this.guestClicksRetry = res.data.guestClicksRetry
          if (res.data.guestClicksRetry) {
            // 网络中断，重试
            this.frameNoticeDialog = true
          } else {
            // 网络错误，请重新预定
            this.frameNetworkDialog = true
          }
        } else if (['200'].includes(res.flag)) {
          sessionStorage.removeItem('bedType_' + params.hotelid)
          sessionStorage.setItem('bedType_' + params.hotelid, this.bedType)
          this.orderno = res.data.orderno
          this.jumpPayOrderPage(1)
        } else if (['511'].includes(res.flag)) {
          this.$router.push({name: 'intercepting', query: {'source': this.source}})
        } else if (['188'].includes(res.flag)) {
          // 额度不足
          this.frameNoLimitDialog = true
        }
      })
    },
    jumpPayOrderPage: function () {
      // 订单信息
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var orderInfoData = {
        'hotelid': params.hotelid,
        'product': params.product,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'source': this.source,
        'orderno': this.orderno
      }
      localStorage.setItem('orderData', JSON.stringify(orderInfoData))

      var autoPay = 1
      if (this.paymentOn === 'pingpong') {
        autoPay = 2
      }

      var ordernInfo = {
        'orderno': this.orderno,
        'source': this.source,
        'autoPay': autoPay,
        'paymentOn': this.paymentOn
      }
      this.$router.push({name: 'WritePay', params: orderInfoData, query: ordernInfo})
    },
    orderVerify: function () {
      // 请求验价数据
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)

      var localUrl = params.hotelUrl
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      this.source = this.common.sourceSet()
      var verifyJson = {
        'type': 3,
        'type_id': params.hotelid,
        'hotelid': params.hotelid,
        'product': params.product,
        'token': token,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'currency': currency,
        'source': this.source,
        'nationality': this.paramsNationality,
        'pageRefresh': this.pageRefresh,
        'sessionid': sessionid,
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'operation': 'orderBookVerify',
        'time': time
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      orderBookVerify(verifyData).then(res => {
        this.frameQuotationDialog = false
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '155') {
          // 无母房型有报价
          this.frameHotelSoldDialog = true
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (['153', '200'].includes(res.flag)) {
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }

          if (res.flag === '153') {
            // 涨价
            this.frameRiseDialog = true
            this.risePrice = res.data.priceRise
          } else if (res.flag === '200') {
            // 成功
            // location.reload()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(verifyData, res, requestTime, responseTime, 'confirmPrice')
        })
      })
    },
    continueBookingFun: function (val) {
      // 继续预订 记录埋点
      this.clickPageAction('continue_order', '', {})

      this.frameRemindDialog = false
      this.pageRefresh = 0
      this.frameQuotationDialog = true
      this.orderVerify()
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameRiseBookingFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    SetFrameNoLimit: function (val) {
      this.frameNoLimitDialog = val
    },
    // 网络中断请重试
    frameNoticeFun: function (val) {
      this.JumpNext()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    countDowm () {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.minute !== 0 && self.second === 0) {
          self.second = 59
          self.minute -= 1
        } else if (self.minute === 0 && self.second === 0) {
          self.second = 0
          self.$emit('countDowmEnd', true)
          clearInterval(self.promiseTimer)
          self.pageVerifyNum++
          // self.frameRiseDialog = true
        } else {
          self.second -= 1
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
      this.frameDialog = true
    },
    login () {
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1, 'username': username1, 'emails': emails, 'tel': tel1, 'specialRequirements': specialRequirements, 'areaCode': this.selectTel, 'nationality': this.selectNat[1]},
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 登录记录埋点
      this.clickPageAction('sign_in', '', {})
      if (this.source !== '') {
        this.$router.push({name: 'login', query: {'source': this.source}})
      } else {
        this.$router.push({name: 'login'})
      }
    },
    loginOut: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')

      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
      var data = this.common.encryptionData(dataJson, this)

      // 退款记录埋点
      this.clickPageAction('sign_out', '', data)

      if (token !== undefined && token !== '') {
        signIn(data).then(res => {
          if (res.flag === '200') {
            this.loginStatus = false
            localStorage.removeItem('token')
            // localStorage.removeItem('getCookie')
            localStorage.removeItem('sessionid')
            localStorage.removeItem('LoginWebsiteAddress')
            location.reload()
          }
        })
      }
    },
    closeCardRemind () {
      this.showCardRemind = false
      this.showCardRemindTwo = false
    },
    getPolicyDia (val) {
      this.policyDialog = val
    },
    getClauseDia (val) {
      this.clauseDialog = val
    },
    showCardRemindInfo () {
      this.showCardRemind = true
    },
    showCardRemindInfoTwo () {
      this.showCardRemindTwo = true
    },
    linkClick (type, click = '1') {
      // 点击 记录埋点
      if (type === 'clause') {
        if (click === '2') {
          this.clauseDialog = true
        }
        this.clickPageAction('writeOrder_terms_use', '', {})
      } else if (type === 'policy') {
        if (click === '2') {
          this.policyDialog = true
        }
        this.clickPageAction('writeOrder_privacy_policy', '', {})
      }
    },
    backToPreviousPage () {
      this.$router.go(-1)
    },
    delCoupon: function () {
      this.orderData.discount = ''
      this.orderData.coupon_id = ''
      this.orderData.discountCode = ''
      this.isDiscount = false
      this.userCouponId = ''
    },
    validatePoints (e) {
      // 只允许输入数字
      this.pointsValue = this.pointsValue.replace(/[^\d]/g, '')
      if (this.pointsValue === '') {
        this.someArray.pointsVal = false
        return
      } else if (this.pointsValue.length > 1 && this.pointsValue.charAt(0) === '0') {
        this.pointsValue = '0'
        this.someArray.pointsVal = false
        return
      }
      // 计算最大可用积分(向下取整到最近的100的倍数)
      const maxPoints = Math.min(
        Math.floor((this.getPayAmount() / this.orderData[this.paymentOn].PointsPriceRatio) / 100) * 100,
        Math.floor(this.orderData.currentPoints / 100) * 100 // 当前可用积分也向下取整到100的倍数
      )
      // 如果输入值超过最大可用积分，则设置为最大值
      if (parseInt(this.pointsValue) > maxPoints) {
        this.pointsValue = String(maxPoints)
      }
      // 验证是否为100的倍数
      if (parseInt(this.pointsValue) % 100 !== 0) {
        this.someArray.pointsVal = true
      } else {
        this.someArray.pointsVal = false
        this.handlePointsBlur()
      }
    },
    // 检查积分输入是否有误
    validatePointsInput () {
      return this.getSomeThing('pointsVal')
    },
    // 新增方法处理失去焦点事件
    handlePointsBlur () {
      var getPointsValue = localStorage.getItem('getPointsValue')
      if (this.pointsValue === getPointsValue ||
          (this.pointsValue === '' && getPointsValue === '0') ||
          (this.pointsValue === '0' && getPointsValue === '')) {
        return
      }
      if (!this.someArray.pointsVal) {
        // 添加防抖，避免频繁调用 API
        if (this.pointsTimer) {
          clearTimeout(this.pointsTimer)
        }
        this.pointsTimer = setTimeout(() => {
          this.pointShow()
        }, 800)
      }
    },
    // 实际支付钱数
    getPayAmount () {
      const basePrice = this.isDiscount
        ? Number(this.orderData[this.paymentOn].disPayPrice) - this.orderData[this.paymentOn].disPTFee
        : Number(this.orderData[this.paymentOn].payPrice) - this.orderData[this.paymentOn].pTFee
      return basePrice
    },
    // 检查积分金额是否超过支付金额
    validatePointsAmount () {
      if (!this.pointsValue) return false
      const points = parseInt(this.pointsValue) / 100
      return points > this.getPayAmount()
    }
  },
  computed: {
    formattedSpecialInstructions () {
      if (!this.hotelPolicyData.special_instructions_en) {
        return ''
      }
      const sentences = this.hotelPolicyData.special_instructions_en.split('.').filter(sentence => sentence.trim() !== '')
      const listItems = sentences.map(sentence => `<li>${sentence.trim()}.</li>`).join('')
      return `<ul>${listItems}</ul>`
    },
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    },
    confirm () {
      if (this.isShowFlight) {
        return this.confirmTransportation && this.confirmAgreement
      } else {
        return this.confirmAgreement
      }
    }
  }
}
</script>

<style scoped>
/* 左侧 menu*/
.el-main{text-align: left;}
.main{width:100%;}

/* 搜索条件 开始 */
.list-content{color: #333; font-size: 14px;}
.avgprice{ color: #616161; font-size: 12px; line-height: 12px;margin-top: -10px;}
/* 详情 */
/deep/ .el-collapse-item__header, .el-collapse, /deep/ .el-collapse-item__wrap{border: none; background-color: #f8f9fa;}
.list-content /deep/ .el-collapse-item__arrow{ display: none;}
.back-button{height: 20px;line-height: 20px;cursor: pointer; width: 60px;}
.back-img{width: 15px; height: 15px; margin: 2.5px; float: left;}
.hotel-info{background-color: #FFF; margin-top: 15px; padding:20px 1.5% 10px 1.5%;border-radius: 5px;}
.el-form-item {
  margin-bottom: 15px; /* Add some spacing between form items */
}
.hotel-name{height: 40px; line-height: 40px; color:rgb(83, 102, 163);font-size: 14px;}
.order-info{font-size: 12px; height: auto; line-height: 30px; clear: both;}
.oneline{clear: both; min-height: 40px; line-height: 40px;}
.price-oneline{clear: both; min-height: 48px; line-height: 48px;}
.oneline span{display: inline-block;}
.left-info{ width: 40%;font-size: 14px; font-weight: 500; float: left;}
.right-info{width: 60%; float: left;font-size: 14px;}
/* 客户信息 */
.hotel-line .msg-username{width:30%;display:inline-block;}
/* /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner, /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{border-color: rgb(220, 135, 107);} */
.hotel-line /deep/ .el-input__inner{border: 1px solid #DCDFE6;}
/deep/ .el-radio__input{margin-bottom: 15px;}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.hotel-info /deep/ .el-input__inner:focus{border: 1px solid rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}

/* 支付方式 */
.payment-text{font-size: 13px; font-weight: 500; color: #333;vertical-align: text-bottom; margin-bottom: 10px;display: inline-block;}

/deep/ .el-radio__input.is-checked .el-radio__inner{border-color:rgba(83, 102, 163, 1);background:rgba(83, 102, 163, 1);}
/deep/ .el-radio__input.is-focus .el-radio__inner, /deep/ .el-radio__input .el-radio__inner:hover{border-color:rgba(83, 102, 163, 1);}
/deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color: rgba(83, 102, 163, 1) !important;}

/* 特殊要求 */
.specialText{height: 80px; /* line-height: 80px; */ font-size: 14px;padding: 0px;border:none;}
.specialText /deep/ textarea{height:100%;resize:none;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;color: #333;}
/deep/ .el-textarea__inner:focus{border-color:rgb(83, 102, 163, 1);}

/deep/ .transportation .el-checkbox__input {
  vertical-align: top !important; /* 将复选框图标顶部对齐 */
  margin-top: 3px;
}
/deep/ .el-checkbox__label {
  white-space: normal !important; /* 强制自动换行 */
  word-break: break-word; /* 允许在单词内部换行，如果需要的话 */
}

.display_button, .display_button:hover {
  background: #909399;
}

.hotel-policies-container {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0px;
  background: #fff;
  padding: 10px 1.5% 0px;
  border-radius: 5px;
}

.policy-block {
  width: 49%;
  margin: 10px 10px 20px 0px;
}

.policy-block h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.policy-block .policy-content {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}

.check-info-container {
  display: flex;
  justify-content: space-between;
}

.check-info-block {
  width: 48%;
}

.check-info-title {
  color: #4E7997;
  font-size: 14px;
  margin-bottom: 10px;
}

.check-info-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.policy-block .policy-content p {
  margin: 5px 0;
}

.policy-block .policy-content ul {
  margin: 5px 0;
  padding-left: 20px;
}

.price-details-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #666;
}

.package-tag {
  background: #F6FFED;
  color: #52C41A;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #B7EB8F
}

.price-sections-container {
  display: flex;
  gap: 29px;
  margin-bottom: 20px;
  align-items: stretch;
}

.price-section {
  flex: 1;
  background: #5366A30F;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex; /* 新增：使内部元素可以使用flex布局 */
  flex-direction: column; /* 新增：使内部元素垂直排列 */
}

.price-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.section-title {
  color: #5366A3;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 700;
}

.price-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1; /* 新增：使其填充可用空间，并将totals推到底部 */
}

.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.green-text {
    color: #2F7000;
}

.divider {
  height: 1px;
  background: #000000;
  margin-top: auto; /* 新增：将分隔线和总计部分推向底部 */
}

.price-item.total {
  font-weight: 600;
}

.total-price {
  display: flex;
  justify-content: justify;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
  font-size: 16px;
  font-weight: 600;
}

.total-price .amount {
  color: #2b3481;
  font-size: 20px;
  margin-left: 5px;
}

.container {
    margin-top: 15px;
    background-color: #ffffff;
    padding: 15px 1%;
    border-radius: 4px;
    line-height: 1.5;
}

.container h1 {
    text-align: left;
    color: rgb(83, 102, 163);
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

/* 政策列布局 */
.policy-columns {
    display: flex;
    /* 允许列在需要时换行，虽然对于两列来说不那么关键 */
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.policy-column {
    flex: 1 1 45%;
    min-width: 300px; /* 确保在小屏幕下换行前有一个最小宽度 */
}

/* CSS规则：用于隐藏空的列 (这需要通过 JS 或模板逻辑来添加 `.empty` 类) */
.policy-column.empty {
    display: none; /* 如果列为空，则完全隐藏该列 */
}

/* 政策模块样式 */
.policy-module {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
}

/* 移除每列中最后一个模块的底部外边距，使布局更紧凑 */
.policy-module:last-child {
    margin-bottom: 0;
}

.policy-module h2 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    padding-left: 0;
}

/deep/ .policy-module ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
}

/deep/ .policy-module li {
    position: relative;
    margin-bottom: 8px;
    padding-left: 0; /* 如果不使用自定义项目符号，则无需内边距 */
    font-size: 13px;
    color: #555;
}

.policy-module-text {
    position: relative;
    margin-bottom: 8px; /* Adjusted: Slightly reduced list item spacing */
    padding-left: 0; /* Adjusted: Removed padding for custom bullet if not needed */
    font-size: 13px; /* Adjusted: Slightly smaller font size */
    color: #555;
}

.policy-module div {
  font-size: 14px;
}

.policy-content >>> li {
  list-style-type: disc;
  margin-left: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .policy-columns {
        flex-direction: column;
        gap: 20px;
    }
    .policy-column {
        min-width: 100%;
    }
    .policy-module {
        padding: 15px; /* Adjust padding for smaller screens if needed */
    }
}

/* 取消政策弹框样式 */
.cancel-policy {
  background: #fff;
  padding: 12px;
  /* max-height: 150px; */
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
}

.cancel-policy .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.cancel-policy .circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #cc0000; /* 修改为边框 */
  background: transparent; /* 背景设置为透明 */
  margin-top: 6px;
  margin-right: 8px;
  flex-shrink: 0;
}

.cancel-policy .text-content {
  flex: 1;
}

.cancel-policy .subtitle {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  font-weight: 500;
}

.cancel-policy .description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* 弹框容器样式 */
.nonFefundable {
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 180px !important;
  height: auto !important;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

/deep/ .facilities-dialog .el-dialog__body{
  padding: 0px 20px 30px;
}

.facilities-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.facilities-list li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.facilities-list li i {
  font-size: 18px;
  margin-right: 10px;
  color: #6c5ce7;
}

.dialog-footer .el-button {
  border-radius: 5px;
}

/* You might need to adjust icon colors if they don't match exactly */
.facilities-list li .el-icon-present,
.facilities-list li .el-icon-time,
.facilities-list li .el-icon-magic-stick {
    color: #20c997;
}

.facilities-divider {
    width: 100%;
    height: 1px;
    background: #e5e6eb;
    margin-bottom: 15px;
    border: none;
  }

.arrow-icon {
  margin-right: 10px; /* 箭头与文字的间距 */
  color: #5366a3; /* 箭头颜色，可以根据品牌色调整 */
  font-size: 0.9em; /* 调整箭头大小 */
}
</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
.el-tooltip__popper.is-light {
  max-width: 300px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  padding: 8px 12px !important;
  background: #999999 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order/WriteOrder.vue